export enum EnumCajuInterest {
  ALREADY_KNOW = "Já conheço a Caju e quero contratar :)",
  WATCH_DEMO = "Assistir demonstração para conhecer e tirar dúvidas",
}
